import '@driftt/react-dates/initialize'

import LoadStyles from '@driftt/tide-core/dist/styles'
import ConnectedApp from '@driftt/traffic-control'
import React from 'react'
import ReactDOM from 'react-dom'

import config from 'config'
import rootReducer from 'modules'

import App from './layouts/App'

import './index.css'

LoadStyles()

const sentryConfig = {
  dsn: config.SENTRY_DSN,
  release: '20251201223416-be4cd04',
  tracesSampleRate: 0,
}

ReactDOM.render(
  <ConnectedApp
    reducers={rootReducer}
    render={() => <App />}
    authClientId={config.AUTH_CLIENT_ID}
    sentryConfig={sentryConfig}
  />,
  document.getElementById('root')
)
